import { motion } from "framer-motion";

export default function MetricCard({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  color = "blue",
  trend 
}) {
  
  const colorMap = {
    blue: "from-blue-50 to-blue-100 border-blue-200",
    green: "from-green-50 to-green-100 border-green-200",
    orange: "from-orange-50 to-orange-100 border-orange-200",
    red: "from-red-50 to-red-100 border-red-200",
    purple: "from-purple-50 to-purple-100 border-purple-200"
  };

  const textColorMap = {
    blue: "text-blue-700",
    green: "text-green-700",
    orange: "text-orange-700",
    red: "text-red-700",
    purple: "text-purple-700"
  };

  const iconBgMap = {
    blue: "bg-blue-100 text-blue-600",
    green: "bg-green-100 text-green-600",
    orange: "bg-orange-100 text-orange-600",
    red: "bg-red-100 text-red-600",
    purple: "bg-purple-100 text-purple-600"
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`bg-gradient-to-br ${colorMap[color]} border rounded-2xl p-6 hover:shadow-lg transition-shadow`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-gray-600 text-sm font-medium mb-1">{title}</p>
          <h3 className={`text-4xl font-bold ${textColorMap[color]} mb-2`}>
            {value}
          </h3>
          {subtitle && (
            <p className="text-xs text-gray-500">{subtitle}</p>
          )}
        </div>
        {Icon && (
          <div className={`${iconBgMap[color]} p-4 rounded-xl`}>
            <Icon size={24} />
          </div>
        )}
      </div>
      {trend && (
        <div className="mt-3 text-xs font-semibold">
          <span className={trend.positive ? "text-green-600" : "text-red-600"}>
            {trend.positive ? "↑" : "↓"} {trend.value}%
          </span>
          <span className="text-gray-500 ml-1">{trend.label}</span>
        </div>
      )}
    </motion.div>
  );
}
